import React, { memo } from "react";
import colors from "app/colors";
import { CheckPlusIcon } from "modules/icons";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import { Button } from "@chakra-ui/react";

interface IProps {
  draftId: string;
  onSend: () => void;
  isSending?: boolean;
}

const ComposeBottomToolbarCreateTaskButton = ({
  draftId,
  onSend,
  isSending,
}: IProps) => {
  const {
    draft,
    isDraftLoaded,
    bottomButtonTypes,
    isUploadingFiles,
    canSendMessage,
  } = useMessageThreadDraft({ draftId });

  if (!draft || !isDraftLoaded) return null;

  if (!bottomButtonTypes.includes("create-task")) {
    return null;
  }

  const isLoading = isUploadingFiles || isSending;

  return (
    <Button
      aria-label="Create task"
      variant="hover"
      rounded="full"
      title="Create task"
      size="md"
      borderRadius="full"
      leftIcon={<CheckPlusIcon fill={colors.white} boxSize={4} />}
      bg={colors.greenPrimary}
      onClick={onSend}
      isLoading={isLoading}
      isDisabled={!canSendMessage}
      color={colors.white}
      fontSize={14}
      fontWeight={600}
      iconSpacing={1}
      p={4}
    >
      Create Task
    </Button>
  );
};

export default memo(ComposeBottomToolbarCreateTaskButton);
